import { IconInstagram } from './IconInstagram'

export default IconInstagram
